import { Injectable, inject } from '@angular/core';
// import { Actions, Effect, ofType } from '@ngrx/effects';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, of } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';
import {
	ActionTypes, DisLikeItem,
	GetAllTypes,
	GetAllTypesError,
	GetAllTypesSuccess,
	GetItem,
	GetItemError,
	GetItems,
	GetItemsByStoreId,
	GetItemsByStoreIdError,
	GetItemsByStoreIdSuccess,
	GetItemsError,
	GetItemsSuccess,
	GetItemSuccess,
	ItemPostComment,
	ItemPostCommentError,
	ItemPostCommentSuccess, LikeItem, LikeItemError, LikeItemReset, LikeItemSuccess,
	AddToCartItem,
	AddToCartItemSuccess,
	AddToCartItemError,
	GetItemFromCart,
	GetItemFromCartSuccess,
	GetItemFromCartError,
	DeleteItemFromCart,
	DeleteItemFromCartSuccess,
	DeleteItemFromCartError,
	RemoveItemFromCart,
	RemoveItemFromCartSuccess,
	RemoveItemFromCartError,
	GetCheckoutData,
	GetCheckoutDataSuccess,
	GetCheckoutDataError,
	phItemPaymentStatus,
	phItemPaymentStatusSuccess,
	phItemPaymentStatusError,
	CompareItems,
	CompareItemsSuccess,
	CompareItemsError,
	GetAllCustomJewellery,
	GetAllCustomJewellerySuccess,
	GetAllCustomJewelleryError,
	CustomJewelleryCheckOutDetail,
	CustomJewelleryCheckOutDetailSuccess,
	CustomJewelleryCheckOutDetailError,
	CustomJewelleryPaymentStatus,
	CustomJewelleryPaymentStatusSuccess,
	CustomJewelleryPaymentStatusError,
	CheckCustomJewPaymentType,
	CheckCustomJewPaymentTypeSuccess,
	CheckCustomJewPaymentTypeError,
	GetReview,
	GetReviewSuccess,
	GetReviewError,
	GetAllItemsForWeb,
	GetAllItemsForWebSuccess,
	GetAllItemsForWebError,
	GetStoreItemsForWeb,
	GetStoreItemsForWebError,
	GetStoreItemsForWebSuccess,
	GetCustomJewelleryPriceDetails,
	GetCustomJewelleryPriceDetailsError,
	GetCustomJewelleryPriceDetailsSuccess,
	GetAllCompareData,
	GetAllCompareDataSuccess,
	GetAllCompareDataError,
	CheckServiceAbility,
	CheckServiceAbilitySuccess,
	CheckServiceAbilityError,
	CountTotalItem,
	CountTotalItemSuccess,
	CountTotalItemError
} from "./item.actions";
import { Helper } from "../../shared/services/Helper.service";
import { ItemService } from "../../home/services/item.service";
import { AlertPopupService } from "../../shared/services/alert-popup.service";
import { Router } from "@angular/router";

@Injectable()
export class ItemEffects {

	// @Effect()
	// GetAllTypes$ = this.actions$.pipe(
	GetAllTypes$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.GetAllTypes),
			map((action: GetAllTypes) => action.payload),
			mergeMap((payload) => {
				return this.itemService.GetAllTypes(null).pipe(
					map((response) => {
						return new GetAllTypesSuccess(response)
					}),
					catchError((error) => of(new GetAllTypesError(error)))
				)
			})
		)
	});
	// );

	// @Effect({ dispatch: false })
	// GetAllTypesSuccess$ = this.actions$.pipe(
	GetAllTypesSuccess$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.GetAllTypesSuccess),
			map((action: GetAllTypesSuccess) => action.payload),
			mergeMap((payload) => {
				return of(null)
			})
		)
	}, { dispatch: false });
	// );

	// @Effect({ dispatch: false })
	// GetAllTypesError$ = this.actions$.pipe(
	GetAllTypesError$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.GetAllTypesError),
			map((action: GetAllTypesError) => action.payload),
			mergeMap((payload) => {
				this.helper.Error$(payload);
				return of(null)
			})
		)
	}, { dispatch: false });
	// );

	// @Effect()
	// GetItemsByStoreId$ = this.actions$.pipe(
	GetItemsByStoreId$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.GetItemsByStoreId),
			map((action: GetItemsByStoreId) => action.payload),
			mergeMap((payload) => {
				return this.itemService.GetItemsByStoreId(payload.storeId, payload.criteria).pipe(
					map((response) => {
						return new GetItemsByStoreIdSuccess(response)
					}),
					catchError((error) => of(new GetItemsByStoreIdError(error)))
				)
			})
		)
	});
	// );

	// @Effect({ dispatch: false })
	// GetItemsByStoreIdSuccess$ = this.actions$.pipe(
	GetItemsByStoreIdSuccess$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.GetItemsByStoreIdSuccess),
			map((action: GetItemsByStoreIdSuccess) => action.payload),
			mergeMap((payload) => {
				return of(null)
			})
		)
	}, { dispatch: false });
	// );

	// @Effect({ dispatch: false })
	// GetItemsByStoreIdError$ = this.actions$.pipe(
	GetItemsByStoreIdError$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.GetItemsByStoreIdError),
			map((action: GetItemsByStoreIdError) => action.payload),
			mergeMap((payload) => {
				this.helper.Error$(payload);
				return of(null)
			})
		)
	}, { dispatch: false });
	// );

	// @Effect()
	// GetItem$ = this.actions$.pipe(
	GetItem$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.GetItem),
			map((action: GetItem) => action.payload),
			mergeMap((payload) => {
				return this.itemService.GetItem(payload.itemId).pipe(
					map((response) => {
						return new GetItemSuccess(response)
					}),
					catchError((error) => of(new GetItemError(error)))
				)
			})
		)
	});
	// );

	// @Effect({ dispatch: false })
	// GetItemSuccess$ = this.actions$.pipe(
	GetItemSuccess$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.GetItemSuccess),
			map((action: GetItemSuccess) => action.payload),
			mergeMap((payload) => {
				return of(null)
			})
		)
	}, { dispatch: false });
	// );

	// @Effect({ dispatch: false })
	// GetItemError$ = this.actions$.pipe(
	GetItemError$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.GetItemError),
			map((action: GetItemError) => action.payload),
			mergeMap((payload) => {
				this.helper.Error$(payload);
				return of(null)
			})
		)
	}, { dispatch: false });
	// );

	// @Effect()
	// GetItems$ = this.actions$.pipe(
	GetItems$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.GetItems),
			map((action: GetItems) => action.payload),
			mergeMap((payload) => {
				return this.itemService.GetItems(payload).pipe(
					map((response) => {
						return new GetItemsSuccess(response)
					}),
					catchError((error) => of(new GetItemsError(error)))
				)
			})
		)
	});
	// );

	// @Effect({ dispatch: false })
	// GetItemsSuccess$ = this.actions$.pipe(
	GetItemsSuccess$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.GetItemsSuccess),
			map((action: GetItemsSuccess) => action.payload),
			mergeMap((payload) => {
				return of(null)
			})
		)
	}, { dispatch: false });
	// );

	// @Effect({ dispatch: false })
	// GetItemsError$ = this.actions$.pipe(
	GetItemsError$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.GetItemsError),
			map((action: GetItemsError) => action.payload),
			mergeMap((payload) => {
				this.helper.Error$(payload);
				return of(null)
			})
		)
	}, { dispatch: false });
	// );

	// @Effect()
	// ItemPostComment$ = this.actions$.pipe(
	ItemPostComment$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.ItemPostComment),
			map((action: ItemPostComment) => action.payload),
			mergeMap((payload) => {
				return this.itemService.PostComment(payload.itemId, payload.payload).pipe(
					map((response: any) => {
						return new ItemPostCommentSuccess(response)
					}),
					catchError((error) => of(new ItemPostCommentError(error)))
				)
			})
		)
	});
	// );

	// @Effect({ dispatch: false })
	// ItemPostCommentSuccess$ = this.actions$.pipe(
	ItemPostCommentSuccess$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.ItemPostCommentSuccess),
			map((action: ItemPostCommentSuccess) => action.payload),
			mergeMap((payload) => {
				return of(null)
			})
		)
	}, { dispatch: false });
	// );

	// @Effect({ dispatch: false })
	// ItemPostCommentError$ = this.actions$.pipe(
	ItemPostCommentError$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.ItemPostCommentError),
			map((action: ItemPostCommentError) => action.payload),
			mergeMap((payload) => {
				this.helper.Error$(payload);
				return of(null)
			})
		)
	}, { dispatch: false });
	// );

	// @Effect()
	// LikeItem$ = this.actions$.pipe(
	LikeItem$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.LikeItem),
			map((action: LikeItem) => action.payload),
			mergeMap((payload) => {
				return this.itemService.LikeItem(payload.itemId).pipe(
					map((response: any) => {
						this.alertPopupService.showInfoAlert('Item Liked');
						return new LikeItemSuccess(response)
					}),
					catchError((error) => of(new LikeItemError(error)))
				)
			})
		)
	});
	// );

	// @Effect()
	// DisLikeItem$ = this.actions$.pipe(
	DisLikeItem$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.DisLikeItem),
			map((action: DisLikeItem) => action.payload),
			mergeMap((payload) => {
				return this.itemService.DisLikeItem(payload.itemId, payload.likeId).pipe(
					map((response: any) => {
						this.alertPopupService.showInfoAlert('Item removed from Liked');
						return new LikeItemSuccess(response)
					}),
					catchError((error) => of(new LikeItemError(error)))
				)
			})
		)
	});
	// );

	// @Effect({ dispatch: false })
	// LikeItemSuccess$ = this.actions$.pipe(
	LikeItemSuccess$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.LikeItemSuccess),
			map((action: LikeItemSuccess) => action.payload),
			mergeMap((payload) => {
				return of(new LikeItemReset());
			})
		)
	}, { dispatch: false });
	// );

	// @Effect({ dispatch: false })
	// LikeItemError$ = this.actions$.pipe(
	LikeItemError$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.LikeItemError),
			map((action: LikeItemError) => action.payload),
			mergeMap((payload) => {
				this.helper.Error$(payload);
				return of(null)
			})
		)
	}, { dispatch: false });
	// );

	// @Effect()
	// CompareItems$ = this.actions$.pipe(
	CompareItems$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.CompareItems),
			map((action: CompareItems) => action.payload),
			mergeMap((payload) => {
				return this.itemService.compareItems(payload).pipe(
					map((response) => {
						return new CompareItemsSuccess(response)
					}),
					catchError((error) => of(new CompareItemsError(error)))
				)
			})
		)
	});
	// );

	// @Effect({ dispatch: false })
	// CompareItemsSuccess$ = this.actions$.pipe(
	CompareItemsSuccess$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.CompareItemsSuccess),
			map((action: CompareItemsSuccess) => action.payload),
			mergeMap((payload) => {
				return of(null)
			})
		)
	}, { dispatch: false });
	// );

	// @Effect({ dispatch: false })
	// CompareItemsError$ = this.actions$.pipe(
	CompareItemsError$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.CompareItemsError),
			map((action: CompareItemsError) => action.payload),
			mergeMap((payload) => {
				this.helper.Error$(payload);
				return of(null)
			})
		)
	}, { dispatch: false });
	// );

	// @Effect()
	// AddToCartItem$ = this.actions$.pipe(
	AddToCartItem$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.AddToCartItem),
			map((action: AddToCartItem) => action.payload),
			mergeMap((payload) => {
				return this.itemService.AddToCartItem(payload).pipe(
					map((response: any) => {
						this.alertPopupService.showInfoAlert('Item Added To Cart');
						let newItemIds = response.items.map(item => item.product.id);
						let existingItemIdsJSON = localStorage.getItem("addedItemIds");
						let existingItemIds: string[] = [];
						if (existingItemIdsJSON) {
							existingItemIds = JSON.parse(existingItemIdsJSON);
						}
						let uniqueNewItemIds = newItemIds.filter(newItemId => !existingItemIds.includes(newItemId));
						const updatedItemIds = existingItemIds.concat(uniqueNewItemIds);
						localStorage.setItem("addedItemIds", JSON.stringify(updatedItemIds));

						return new AddToCartItemSuccess({
							payload,
							response
						})
					}),
					catchError((error) => of(new AddToCartItemError(error)))
				)
			})
		)
	});
	// );

	// @Effect({ dispatch: false })
	// AddToCartItemSuccess$ = this.actions$.pipe(
	AddToCartItemSuccess$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.AddToCartItemSuccess),
			map((action: AddToCartItemSuccess) => action.payload),
			mergeMap((payload) => {
				return of();
			})
		)
	}, { dispatch: false });
	// );

	// @Effect({ dispatch: false })
	// AddToCartItemError$ = this.actions$.pipe(
	AddToCartItemError$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.AddToCartItemError),
			map((action: AddToCartItemError) => action.payload),
			mergeMap((payload) => {
				this.helper.Error$(payload);
				return of(payload.status)
			})
		)
	}, { dispatch: false });
	// );

	// @Effect()
	// GetItemFromCart$ = this.actions$.pipe(
	GetItemFromCart$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.GetItemFromCart),
			map((action: GetItemFromCart) => action.payload),
			mergeMap((payload) => {
				return this.itemService.GetItemFromCart().pipe(
					map((response: any) => {
						return new GetItemFromCartSuccess(response)
					}),
					catchError((error) => of(new GetItemFromCartError(error)))
				)
			})
		)
	});
	// );

	// @Effect({ dispatch: false })
	// GetItemFromCartSuccess$ = this.actions$.pipe(
	GetItemFromCartSuccess$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.GetItemFromCartSuccess),
			map((action: GetItemFromCartSuccess) => action.payload),
			mergeMap((payload) => {
				return of();
			})
		)
	}, { dispatch: false });
	// );

	// @Effect({ dispatch: false })
	// GetItemFromCartError$ = this.actions$.pipe(
	GetItemFromCartError$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.GetItemFromCartError),
			map((action: GetItemFromCartError) => action.payload),
			mergeMap((payload) => {
				this.helper.Error$(payload);
				return of(null)
			})
		)
	}, { dispatch: false });
	// );

	// @Effect()
	// DeleteItemFromCart$ = this.actions$.pipe(
	DeleteItemFromCart$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.DeleteItemFromCart),
			map((action: DeleteItemFromCart) => action.payload),
			mergeMap((payload) => {
				return this.itemService.DeleteItemFromCart().pipe(
					map((response: any) => {
						this.alertPopupService.showInfoAlert('All Items from the cart are removed !');
						return new DeleteItemFromCartSuccess(response)
					}),
					catchError((error) => of(new DeleteItemFromCartError(error)))
				)
			})
		)
	});
	// );

	// @Effect({ dispatch: true })
	// DeleteItemFromCartSuccess$ = this.actions$.pipe(
	DeleteItemFromCartSuccess$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.DeleteItemFromCartSuccess),
			map((action: DeleteItemFromCartSuccess) => action.payload),
			mergeMap((payload) => {
				return of();
			})
		)
	}, { dispatch: false });
	// );

	// @Effect({ dispatch: false })
	// DeleteItemFromCartError$ = this.actions$.pipe(
	DeleteItemFromCartError$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.DeleteItemFromCartError),
			map((action: DeleteItemFromCartError) => action.payload),
			mergeMap((payload) => {
				this.helper.Error$(payload);
				return of(null)
			})
		)
	}, { dispatch: false });
	// );

	// @Effect()
	// RemoveItemFromCart$ = this.actions$.pipe(
	RemoveItemFromCart$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.RemoveItemFromCart),
			map((action: RemoveItemFromCart) => action.payload),
			mergeMap((payload) => {
				return this.itemService.RemoveItemFromCart(payload).pipe(
					map((response: any) => {
						return new RemoveItemFromCartSuccess(response)
					}),
					catchError((error) => of(new RemoveItemFromCartError(error)))
				)
			})
		)
	});
	// );

	// @Effect({ dispatch: false })
	// RemoveItemFromCartSuccess$ = this.actions$.pipe(
	RemoveItemFromCartSuccess$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.RemoveItemFromCartSuccess),
			map((action: RemoveItemFromCartSuccess) => action.payload),
			mergeMap((payload) => {
				this.alertPopupService.showInfoAlert('Item removed from cart successfully');
				this.router.navigate(['box']); //TBD
				return of();
			})
		)
	}, { dispatch: false });
	// );

	// @Effect({ dispatch: false })
	// RemoveItemFromCartError$ = this.actions$.pipe(
	RemoveItemFromCartError$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.RemoveItemFromCartError),
			map((action: RemoveItemFromCartError) => action.payload),
			mergeMap((payload) => {
				this.helper.Error$(payload);
				return of(null)
			})
		)
	}, { dispatch: false });
	// );

	// @Effect()
	// GetCheckoutData$ = this.actions$.pipe(
	GetCheckoutData$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.GetCheckoutData),
			map((action: GetCheckoutData) => action.payload),
			mergeMap((payload) => {
				return this.itemService.GetCheckoutData(payload).pipe(
					map((response: any) => {
						return new GetCheckoutDataSuccess(response)
					}),
					catchError((error) => of(new GetCheckoutDataError(error)))
				)
			})
		)
	});
	// );

	// @Effect({ dispatch: true })
	// GetCheckoutDataSuccess$ = this.actions$.pipe(
	GetCheckoutDataSuccess$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.GetCheckoutDataSuccess),
			map((action: GetCheckoutDataSuccess) => action.payload),
			mergeMap((payload) => {
				return of();
			})
		)
	}, { dispatch: false });
	// );

	// @Effect({ dispatch: false })
	// GetCheckoutDataError$ = this.actions$.pipe(
	GetCheckoutDataError$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.GetCheckoutDataError),
			map((action: GetCheckoutDataError) => action.payload),
			mergeMap((payload) => {
				this.helper.Error$(payload);
				return of(null)
			})
		)
	}, { dispatch: false });
	// );

	// @Effect()
	// phItemPaymentStatus$ = this.actions$.pipe(
	phItemPaymentStatus$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.phItemPaymentStatus),
			map((action: phItemPaymentStatus) => action.payload),
			mergeMap((payload) => {
				return this.itemService.phItemPaymentStatus(payload).pipe(
					map((response: any) => {
						return new phItemPaymentStatusSuccess(response)
					}),
					catchError((error) => of(new phItemPaymentStatusError(error)))
				)
			})
		)
	});
	// );

	// @Effect({ dispatch: false })
	// phItemPaymentStatusSuccess$ = this.actions$.pipe(
	phItemPaymentStatusSuccess$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.phItemPaymentStatusSuccess),
			map((action: phItemPaymentStatusSuccess) => action.payload),
			mergeMap((payload) => {
				return of();
			})
		)
	}, { dispatch: false });
	// );

	// @Effect({ dispatch: false })
	// phItemPaymentStatusError$ = this.actions$.pipe(
	phItemPaymentStatusError$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.phItemPaymentStatusError),
			map((action: phItemPaymentStatusError) => action.payload),
			mergeMap((payload) => {
				this.helper.Error$(payload);
				return of(null)
			})
		)
	}, { dispatch: false });
	// );

	// @Effect()
	// GetAllCustomJewellery$ = this.actions$.pipe(
	GetAllCustomJewellery$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.GetAllCustomJewellery),
			map((action: GetAllCustomJewellery) => action.payload),
			mergeMap((payload) => {
				return this.itemService.GetAllCustomJewellery(payload).pipe(
					map((response: any) => {
						return new GetAllCustomJewellerySuccess(response)
					}),
					catchError((error) => of(new GetAllCustomJewelleryError(error)))
				)
			})
		)
	});
	// );

	// @Effect({ dispatch: false })
	// GetAllCustomJewellerySuccess$ = this.actions$.pipe(
	GetAllCustomJewellerySuccess$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.GetAllCustomJewellerySuccess),
			map((action: GetAllCustomJewellerySuccess) => action.payload),
			mergeMap((payload) => {
				return of();
			})
		)
	}, { dispatch: false });
	// );

	// @Effect({ dispatch: false })
	// GetAllCustomJewelleryError$ = this.actions$.pipe(
	GetAllCustomJewelleryError$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.GetAllCustomJewelleryError),
			map((action: GetAllCustomJewelleryError) => action.payload),
			mergeMap((payload) => {
				this.helper.Error$(payload);
				return of(null)
			})
		)
	}, { dispatch: false });
	// );

	// @Effect()
	// GetReview$ = this.actions$.pipe(
	GetReview$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.GetReview),
			map((action: GetReview) => action.payload),
			mergeMap((payload) => {
				return this.itemService.GetReview(payload).pipe(
					map((response: any) => {
						return new GetReviewSuccess(response)
					}),
					catchError((error) => of(new GetReviewError(error)))
				)
			})
		)
	});
	// );

	// @Effect({ dispatch: false })
	// GetReviewSuccess$ = this.actions$.pipe(
	GetReviewSuccess$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.GetReviewSuccess),
			map((action: GetReviewSuccess) => action.payload),
			mergeMap((payload) => {
				return of();
			})
		)
	}, { dispatch: false });
	// );

	// @Effect({ dispatch: false })
	// GetReviewError$ = this.actions$.pipe(
	GetReviewError$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.GetReviewError),
			map((action: GetReviewError) => action.payload),
			mergeMap((payload) => {
				this.helper.Error$(payload);
				return of(null)
			})
		)
	}, { dispatch: false });
	// );

	// @Effect()
	// CustomJewelleryCheckOutDetail$ = this.actions$.pipe(
	CustomJewelleryCheckOutDetail$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.CustomJewelleryCheckOutDetail),
			map((action: CustomJewelleryCheckOutDetail) => action.payload),
			mergeMap((payload) => {
				return this.itemService.CustomJewelleryCheckOutDetail(payload).pipe(
					map((response: any) => {
						return new CustomJewelleryCheckOutDetailSuccess(response)
					}),
					catchError((error) => of(new CustomJewelleryCheckOutDetailError(error)))
				)
			})
		)
	});
	// );

	// @Effect({ dispatch: false })
	// CustomJewelleryCheckOutDetailSuccess$ = this.actions$.pipe(
	CustomJewelleryCheckOutDetailSuccess$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.CustomJewelleryCheckOutDetailSuccess),
			map((action: CustomJewelleryCheckOutDetailSuccess) => action.payload),
			mergeMap((payload) => {
				return of();
			})
		)
	}, { dispatch: false });
	// );

	// @Effect({ dispatch: false })
	// CustomJewelleryCheckOutDetailError$ = this.actions$.pipe(
	CustomJewelleryCheckOutDetailError$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.CustomJewelleryCheckOutDetailError),
			map((action: CustomJewelleryCheckOutDetailError) => action.payload),
			mergeMap((payload) => {
				this.helper.Error$(payload);
				return of(null)
			})
		)
	}, { dispatch: false });
	// );

	// @Effect()
	// GetAllItemsForWeb$ = this.actions$.pipe(
	GetAllItemsForWeb$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.GetAllItemsForWeb),
			map((action: GetAllItemsForWeb) => action.payload),
			mergeMap((payload) => {
				return this.itemService.GetAllItemsForWeb(payload).pipe(
					map((response) => {
						return new GetAllItemsForWebSuccess(response)
					}),
					catchError((error) => of(new GetAllItemsForWebError(error)))
				)
			})
		)
	});
	// );

	// @Effect({ dispatch: false })
	// GetAllItemsForWebSuccess$ = this.actions$.pipe(
	GetAllItemsForWebSuccess$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.GetAllItemsForWebSuccess),
			map((action: GetAllItemsForWebSuccess) => action.payload),
			mergeMap((payload) => {
				return of(null)
			})
		)
	}, { dispatch: false });
	// );

	// @Effect({ dispatch: false })
	// GetAllItemsForWebError$ = this.actions$.pipe(
	GetAllItemsForWebError$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.GetAllItemsForWebError),
			map((action: GetAllItemsForWebError) => action.payload),
			mergeMap((payload) => {
				this.helper.Error$(payload);
				return of(null)
			})
		)
	}, { dispatch: false });
	// );

	// @Effect()
	// CustomJewelleryPaymentStatus$ = this.actions$.pipe(
	CustomJewelleryPaymentStatus$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.CustomJewelleryPaymentStatus),
			map((action: CustomJewelleryPaymentStatus) => action.payload),
			mergeMap((payload) => {
				return this.itemService.CustomJewelleryPaymentStatus(payload.order_id, payload.params).pipe(
					map((response: any) => {
						return new CustomJewelleryPaymentStatusSuccess(response)
					}),
					catchError((error) => of(new CustomJewelleryPaymentStatusError(error)))
				)
			})
		)
	});
	// );

	// @Effect({ dispatch: false })
	// CustomJewelleryPaymentStatusSuccess$ = this.actions$.pipe(
	CustomJewelleryPaymentStatusSuccess$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.CustomJewelleryPaymentStatusSuccess),
			map((action: CustomJewelleryPaymentStatusSuccess) => action.payload),
			mergeMap((payload) => {
				return of();
			})
		)
	}, { dispatch: false });
	// );

	// @Effect({ dispatch: false })
	// CustomJewelleryPaymentStatusError$ = this.actions$.pipe(
	CustomJewelleryPaymentStatusError$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.CustomJewelleryPaymentStatusError),
			map((action: CustomJewelleryPaymentStatusError) => action.payload),
			mergeMap((payload) => {
				this.helper.Error$(payload);
				return of(null)
			})
		)
	}, { dispatch: false });
	// );

	// @Effect()
	// CheckCustomJewPaymentType$ = this.actions$.pipe(
	CheckCustomJewPaymentType$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.CheckCustomJewPaymentType),
			map((action: CheckCustomJewPaymentType) => action.payload),
			mergeMap((payload) => {
				return this.itemService.CheckCustomJewPaymentType(payload.itemId).pipe(
					map((response: any) => {
						return new CheckCustomJewPaymentTypeSuccess(response)
					}),
					catchError((error) => of(new CheckCustomJewPaymentTypeError(error)))
				)
			})
		)
	});
	// );

	// @Effect({ dispatch: false })
	// CheckCustomJewPaymentTypeSuccess$ = this.actions$.pipe(
	CheckCustomJewPaymentTypeSuccess$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.CheckCustomJewPaymentTypeSuccess),
			map((action: CheckCustomJewPaymentTypeSuccess) => action.payload),
			mergeMap((payload) => {
				return of();
			})
		)
	}, { dispatch: false });
	// );

	// @Effect({ dispatch: false })
	// CheckCustomJewPaymentTypeError$ = this.actions$.pipe(
	CheckCustomJewPaymentTypeError$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.CheckCustomJewPaymentTypeError),
			map((action: CheckCustomJewPaymentTypeError) => action.payload),
			mergeMap((payload) => {
				this.helper.Error$(payload);
				return of(null)
			})
		)
	}, { dispatch: false });
	// );

	// @Effect()
	// GetCustomJewelleryPriceDetails$ = this.actions$.pipe(
	GetCustomJewelleryPriceDetails$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.GetCustomJewelleryPriceDetails),
			map((action: GetCustomJewelleryPriceDetails) => action.payload),
			mergeMap((payload) => {
				return this.itemService.GetCustomJewelleryPriceDetails(payload).pipe(
					map((response: any) => {
						return new GetCustomJewelleryPriceDetailsSuccess(response)
					}),
					catchError((error) => of(new GetCustomJewelleryPriceDetailsError(error)))
				)
			})
		)
	});
	// );

	// @Effect({ dispatch: true })
	// GetCustomJewelleryPriceDetailsSuccess$ = this.actions$.pipe(
	GetCustomJewelleryPriceDetailsSuccess$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.GetCustomJewelleryPriceDetailsSuccess),
			map((action: GetCustomJewelleryPriceDetailsSuccess) => action.payload),
			mergeMap((payload) => {
				return of();
			})
		)
	}, { dispatch: false });
	// );

	// @Effect({ dispatch: false })
	// GetCustomJewelleryPriceDetailsError$ = this.actions$.pipe(
	GetCustomJewelleryPriceDetailsError$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.GetCustomJewelleryPriceDetailsError),
			map((action: GetCustomJewelleryPriceDetailsError) => action.payload),
			mergeMap((payload) => {
				this.helper.Error$(payload);
				return of(null)
			})
		)
	}, { dispatch: false });
	// );

	// @Effect()
	// GetStoreItemsForWeb$ = this.actions$.pipe(
	GetStoreItemsForWeb$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.GetStoreItemsForWeb),
			map((action: GetStoreItemsForWeb) => action.payload),
			mergeMap((payload) => {
				return this.itemService.GetStoreItemsForWeb(payload.storeId, payload.criteria).pipe(
					map((response) => {
						return new GetStoreItemsForWebSuccess(response)
					}),
					catchError((error) => of(new GetStoreItemsForWebError(error)))
				)
			})
		)
	});
	// );

	// @Effect({ dispatch: false })
	// GetStoreItemsForWebSuccess$ = this.actions$.pipe(
	GetStoreItemsForWebSuccess$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.GetStoreItemsForWebSuccess),
			map((action: GetStoreItemsForWebSuccess) => action.payload),
			mergeMap((payload) => {
				return of(null)
			})
		)
	}, { dispatch: false });
	// );

	// @Effect({ dispatch: false })
	// GetStoreItemsForWebError$ = this.actions$.pipe(
	GetStoreItemsForWebError$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.GetStoreItemsForWebError),
			map((action: GetStoreItemsForWebError) => action.payload),
			mergeMap((payload) => {
				this.helper.Error$(payload);
				return of(null)
			})
		)
	}, { dispatch: false });
	// );

	// @Effect()
	// GetAllCompareData$ = this.actions$.pipe(
	GetAllCompareData$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.GetAllCompareData),
			map((action: GetAllCompareData) => action.payload),
			mergeMap((payload) => {
				return this.itemService.GetAllCompareData(payload).pipe(
					map((response) => {
						return new GetAllCompareDataSuccess(response)
					}),
					catchError((error) => of(new GetAllCompareDataError(error)))
				)
			})
		)
	});
	// );

	// @Effect({ dispatch: false })
	// GetAllCompareDataSuccess$ = this.actions$.pipe(
	GetAllCompareDataSuccess$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.GetAllCompareDataSuccess),
			map((action: GetAllCompareDataSuccess) => action.payload),
			mergeMap((payload) => {
				return of(null)
			})
		)
	}, { dispatch: false });
	// );

	// @Effect({ dispatch: false })
	// GetAllCompareDataError$ = this.actions$.pipe(
	GetAllCompareDataError$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.GetAllCompareDataError),
			map((action: GetAllCompareDataError) => action.payload),
			mergeMap((payload) => {
				this.helper.Error$(payload);
				return of(null)
			})
		)
	}, { dispatch: false });
	// );

	// @Effect()
	// CheckServiceAbility$ = this.actions$.pipe(
	CheckServiceAbility$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.CheckServiceAbility),
			map((action: CheckServiceAbility) => action.payload),
			mergeMap((payload) => {
				return this.itemService.CheckServiceAbility(payload).pipe(
					map((response) => {
						return new CheckServiceAbilitySuccess(response)
					}),
					catchError((error) => of(new CheckServiceAbilityError(error)))
				)
			})
		)
	});
	// );

	// @Effect({ dispatch: false })
	// CheckServiceAbilitySuccess$ = this.actions$.pipe(
	CheckServiceAbilitySuccess$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.CheckServiceAbilitySuccess),
			map((action: CheckServiceAbilitySuccess) => action.payload),
			mergeMap((payload) => {
				if (payload?.DeliveryService === true) {
					this.alertPopupService.showInfoAlert('Pincode is Available for delivery.');
				} else {
					this.alertPopupService.showInfoAlert('Pincode is not available for delivery.');
				}
				return of(null)
			})
		)
	}, { dispatch: false });
	// );

	// @Effect({ dispatch: false })
	// CheckServiceAbilityError$ = this.actions$.pipe(
	CheckServiceAbilityError$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.CheckServiceAbilityError),
			map((action: CheckServiceAbilityError) => action.payload),
			mergeMap((payload) => {
				this.helper.Error$(payload);
				return of(null)
			})
		)
	}, { dispatch: false });
	// );

	// @Effect()
	// CountTotalItem$ = this.actions$.pipe(
	CountTotalItem$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.CountTotalItem),
			map((action: CountTotalItem) => action.payload),
			mergeMap((payload) => {
				return this.itemService.CountTotalItem(payload.storeId).pipe(
					map((response) => {
						return new CountTotalItemSuccess(response)
					}),
					catchError((error) => of(new CountTotalItemError(error)))
				)
			})
		)
	});
	// );

	// @Effect({ dispatch: false })
	// CountTotalItemSuccess$ = this.actions$.pipe(
	CountTotalItemSuccess$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.CountTotalItemSuccess),
			map((action: CountTotalItemSuccess) => action.payload),
			mergeMap((payload) => {
				return of(null)
			})
		)
	}, { dispatch: false });
	// );

	// @Effect({ dispatch: false })
	// CountTotalItemError$ = this.actions$.pipe(
	CountTotalItemError$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.CountTotalItemError),
			map((action: CountTotalItemError) => action.payload),
			mergeMap((payload) => {
				this.helper.Error$(payload);
				return of(null)
			})
		)
	}, { dispatch: false });
	// );

	constructor(
		private actions$: Actions,
		private helper: Helper,
		private itemService: ItemService,
		private alertPopupService: AlertPopupService,
		private router: Router,
	) {
	}
}
